import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import profilApi from "../../api/profilApi";
import "./Success.css";
import HeaderNA from "../Menu/HeaderNA";
import { useDispatch } from "react-redux";
import { setIsBindPay, setUserEmail, setUserId } from "../Login/loginSlice";

const Success = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [userData, setUserData] = useState(null);
    const [error, setError] = useState(null);
    // const email = new URLSearchParams(location.search).get("email");
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                // console.log('email', email)
                const res_profile = await profilApi.fetchUserData(email);
                // console.log('fetchUserData', res_profile.data)
                setUserData(res_profile.data.user);

                dispatch(setUserId(res_profile.data.user.id))
                dispatch(setUserEmail(email))
                dispatch(setIsBindPay(res_profile.data.hasPaymentOfOneRub))
                const dialogId = localStorage.getItem('dialogId');
                navigate('/chat');
            } catch (err) {
                setError("Не удалось получить информацию о пользователе.");
            }
        };

        if (email) {
            fetchUserData();
        }
    }, [email]);

    return (
        <>
            <HeaderNA />
            <div className="success-container">
                <h1>Оплата прошла успешно</h1>
                {error ? (
                    <p>{error}</p>
                ) : userData ? (
                    <div>
                        <p>{userData.email}!</p>
                        <button onClick={() => { navigate('/chat') }}>
                            Перейти в чат
                        </button>
                    </div>
                ) : (
                    <p>Загружаем информацию о пользователе...</p>
                )}
            </div>
        </>
    );
};

export default Success;
